export var BillingAccountType = /*#__PURE__*/ function(BillingAccountType) {
    BillingAccountType["Enterprise"] = "Enterprise";
    BillingAccountType["Individual"] = "Individual";
    BillingAccountType["Partner"] = "Partner";
    return BillingAccountType;
}({});
export var BillingAgreementType = /*#__PURE__*/ function(BillingAgreementType) {
    BillingAgreementType["MicrosoftCustomerAgreement"] = "MicrosoftCustomerAgreement";
    BillingAgreementType["EnterpriseAgreement"] = "EnterpriseAgreement";
    BillingAgreementType["MicrosoftOnlineServicesProgram"] = "MicrosoftOnlineServicesProgram";
    BillingAgreementType["MicrosoftPartnerAgreement"] = "MicrosoftPartnerAgreement";
    return BillingAgreementType;
}({});
export var EnrollmentChannelType = /*#__PURE__*/ function(EnrollmentChannelType) {
    EnrollmentChannelType["EaDirect"] = "EaDirect";
    EnrollmentChannelType["EaIndirect"] = "EaIndirect";
    return EnrollmentChannelType;
}({});
